import { render, staticRenderFns } from "./MultipleSort.vue?vue&type=template&id=72027fe0&scoped=true"
import script from "./MultipleSort.vue?vue&type=script&lang=js"
export * from "./MultipleSort.vue?vue&type=script&lang=js"
import style0 from "./MultipleSort.vue?vue&type=style&index=0&id=72027fe0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72027fe0",
  null
  
)

export default component.exports